const getDefaultState = () => {
    return {
        drawer: true,
        mobileDrawerState: false,
    }
}

const state = getDefaultState()

const getters = {
    drawer(state: any) {
        return state.drawer
    },

    mobileDrawerState: (state) => state.mobileDrawerState,
}

const mutations = {
    drawer(state: any) {
        state.drawer = !state.drawer
    },

    toggleMobileDrawerState(state, data) {
        state.mobileDrawerState = data
    },

    //RESET
    resetDrawer(state: any) {
        const initial: any = getDefaultState()
        Object.keys(initial).forEach((key) => {
            state[key] = initial[key]
        })
    },
}

export default {
    state,
    getters,
    mutations,
}
